import { useMutation } from '@tanstack/react-query'
import { aiProxyBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface DocumentsByTypeItem {
  type: string
  documentNames: string[]
}

export type ExtractCertificateFieldsPayload =
  | {
      text: string
      documentsByType: DocumentsByTypeItem[]
      primaryDocumentNames?: never
    }
  | {
      text: string
      documentsByType?: never
      primaryDocumentNames: string[]
    }

export interface ExtractCertificateFieldsResponse {
  documentType: string | null
  documentName: string | null
  issueDate: string | null
  expiryDate: string | null
  // Tech manager only fields
  documentCategories?: string[] | null
  certificateIssuer?: string | null
  lastSurvey?: string | null
  nextSurvey?: string | null
  certificateNumber?: string | null
  referenceNumber?: string | null
  isDigitalCertificate?: boolean | null
  noExpiryDate?: boolean | null
  noNextSurvey?: boolean | null
}

export function useExtractCertificateFields() {
  const fetchRequest = useFetch<ExtractCertificateFieldsResponse>()

  return useMutation<
    ExtractCertificateFieldsResponse,
    Error,
    ExtractCertificateFieldsPayload
  >({
    mutationFn: (payload: ExtractCertificateFieldsPayload) =>
      fetchRequest(
        `${aiProxyBase()}/documents/extract-certificate-fields`,
        undefined,
        payload,
        'POST',
      ),
  })
}
